import * as React from 'react';
import * as styles from './PayPalIcon.scss';

export default (props: any) => (
  <img
    className={styles.paypalLogo}
    src="https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/payPal.svg"
    style={props.style}
  />
);



// WEBPACK FOOTER //
// ./components/icons/PayPalIcon/PayPalIcon.tsx